import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { css } from "./index";
import { get } from "./get";
import { StyleSheet } from "react-native";
export function mapPropsToStyledComponent(props, options) {
    var themeKey = options.themeKey, defaultStyle = options.defaultStyle, defaultVariant = options.defaultVariant, _options_defaultVariants = options.defaultVariants, defaultVariants = _options_defaultVariants === void 0 ? [] : _options_defaultVariants;
    var breakpoint = props.breakpoint, sx = props.sx, theme = props.theme, variant = props.variant, style = props.style, variants = props.variants;
    // Override the defaults with added ones; don't get rid of them altogether
    var multipleVariants = _to_consumable_array(defaultVariants).concat([
        defaultVariant
    ]);
    if (variants === null || variants === void 0 ? void 0 : variants.length) {
        multipleVariants = _to_consumable_array(multipleVariants).concat(_to_consumable_array(variants));
    }
    // If a variant exists make it take precedence
    if (variant) multipleVariants = _to_consumable_array(multipleVariants).concat([
        variant
    ]);
    multipleVariants = multipleVariants.filter(Boolean);
    var maybeUnstyledVariantObjectFromTheme = get(theme, themeKey + "." + variant, get(theme, variant || defaultVariant));
    // const variantStyle = css(unstyledVariant, breakpoint)({ theme, themeKey })
    // get the font-family from the variant, and pass it to the other styles as a fallback.
    // if there is no font-family in the variant, check the defaultStyle
    // this lets us support customFonts/font weights (https://github.com/nandorojo/dripsy/issues/51)
    var fontFamily = (maybeUnstyledVariantObjectFromTheme || {}).fontFamily;
    fontFamily = fontFamily || (defaultStyle === null || defaultStyle === void 0 ? void 0 : defaultStyle.fontFamily);
    var baseStyle = css(defaultStyle, breakpoint)({
        theme: theme,
        fontFamily: fontFamily,
        themeKey: themeKey
    });
    // @ts-ignore
    var multipleVariantsStyle = multipleVariants.map(function(variantKey) {
        return css(get(theme, themeKey + "." + variantKey, get(theme, variantKey)), breakpoint)({
            theme: theme,
            fontFamily: fontFamily,
            themeKey: themeKey
        });
    }).reduce(function() {
        var prev = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, next = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return _object_spread({}, prev, next);
    }, {});
    var superStyle = css(sx, breakpoint)({
        theme: theme,
        fontFamily: fontFamily,
        themeKey: themeKey
    });
    var createStyleSheet = function(style) {
        var stylesheet = StyleSheet.create({
            style: style
        });
        return stylesheet.style;
    };
    var baseStyleSheet = createStyleSheet(_object_spread({}, baseStyle, multipleVariantsStyle));
    var superStyleSheet = createStyleSheet(superStyle);
    var styles = [
        // order the styles from default, to variant, style, and finally sx
        baseStyleSheet
    ].concat(_to_consumable_array(Array.isArray(style) ? style : [
        style
    ]), [
        superStyleSheet
    ]);
    if (typeof style == "function") {
        // for Pressable, we pass a function prop to style
        styles = function(interactionState) {
            return [
                baseStyleSheet,
                style(interactionState),
                superStyleSheet
            ];
        };
    }
    return {
        styles: styles
    };
}
